<template>
<div class="chapter">
<div class="inner_page">
<p class="title-head">CONTENTS</p>
<table>
<colgroup>
<col width="40px"/>
<col width="350px"/>
</colgroup>
<tbody>
<tr><td colspan="2"><span href="#/Title" title="Link target outside of Sample">Title Page</span></td></tr>
<tr><td colspan="2"><span href="#/Copyright" title="Link target outside of Sample">Copyright Page</span></td></tr>
<tr><td colspan="2"><a href="#/Acknowledgements#Ack">Acknowledgments</a></td></tr>
<tr><td colspan="2"><a href="#/Introduction#Int">Introduction</a></td></tr>
<tr><td><a href="#/Chapter01#C1">1.</a></td><td><a href="#/Chapter01#C1">World Champions and International Hall of Famers</a></td></tr>
<tr><td><span href="#/Chapter02#C2" title="Link target outside of Sample">2.</span></td><td><span href="#/Chapter02#C2" title="Link target outside of Sample">World Title Challengers</span></td></tr>
<tr><td><span href="#/Chapter03#C3" title="Link target outside of Sample">3.</span></td><td><span href="#/Chapter03#C3" title="Link target outside of Sample">State and Regional Champions</span></td></tr>
<tr><td><span href="#/Chapter04#C4" title="Link target outside of Sample">4.</span></td><td><span href="#/Chapter04#C4" title="Link target outside of Sample">Local Heroes</span></td></tr>
<tr><td><span href="#/Chapter05#C5" title="Link target outside of Sample">5.</span></td><td><span href="#/Chapter05#C5" title="Link target outside of Sample">Non-Boxers</span></td></tr>
<tr><td colspan="2"><span href="#/Pennsylvania#Penn" title="Link target outside of Sample">Pennsylvania Boxing Hall of Fame Inductees 1958–2023</span></td></tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?22f445b7